module.exports = __webpack_public_path__ + "assets/img/00198.3342d503.png";